"use client";
import * as React from "react";
const SvgSearchRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M11.732 10.318h-.741l-.263-.253a6.095 6.095 0 0 0 1.389-5.009C11.676 2.45 9.498.366 6.87.047a6.103 6.103 0 0 0-6.823 6.82c.319 2.626 2.402 4.802 5.011 5.243a6.104 6.104 0 0 0 5.012-1.388l.253.262v.741l3.989 3.987a.992.992 0 0 0 1.398 0 .99.99 0 0 0 0-1.398l-3.979-3.996Zm-5.631 0a4.216 4.216 0 0 1-4.223-4.22A4.216 4.216 0 0 1 6.1 1.876a4.216 4.216 0 0 1 4.223 4.22A4.216 4.216 0 0 1 6.1 10.317Z" }));
export {
  SvgSearchRound as default
};
